module.exports = __webpack_public_path__ + "img/video-1.8f779e23.png";